// location constants
export const NEXT_PUBLIC_GOOGLE_MAP_API = process.env.NEXT_PUBLIC_GOOGLE_MAP_API;
export const NEXT_PUBLIC_GOOGLE_MAP_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;
export const NEXT_PUBLIC_GOOGLE_MAP_GEOCODE_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAP_GEOCODE_API_KEY;
export const NEXT_PUBLIC_PHARMACY_SERVICEABILITY_API_BASE_URL =
  process.env.NEXT_PUBLIC_PHARMACY_SERVICEABILITY_API_BASE_URL;
export const NEXT_PUBLIC_PHARMACY_SERVICEABILITY_TOKEN = process.env.NEXT_PUBLIC_PHARMACY_SERVICEABILITY_TOKEN;
export const PINCODE_MAXLENGTH = 6;
export const GEO_POSITION_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 20000,
  maximumAge: 1,
};
export const LOCATION_SOFT_NUDGE_TIMEOUT = 10000;

export const GEO_NAVIGATOR_PERMISSIONS = {
  GRANTED: "granted",
  DENIED: "denied",
  PROMPT: "prompt",
};
export const BILLING_NAME_MAX_LENGTH = 50;
export const MAXLENGTH_ADDRESS_LINE_ONE = 60;
export const MAXLENGTH_ADDRESS_LINE_TWO = 60;
export const MAXLENGTH_ADDRESS_LANDMARK = 50;
export const MAXLENGTH_ADDRESS_NICKNAME = 50;
export const DEFAULT_LAT = 20.5937,
  DEFAULT_LNG = 78.9629,
  DEFAULT_CART_PINCODE = "414102";
